<template>
  <div class="image-container" :class="props.isLarge ? 'large' : ''">
    <img :src="props.image.thumbnailUrl || props.image.url" @contextmenu.prevent alt="Property Image" />
    <template v-if="props.isCover">
      <div class="cover-badge">Cover photo</div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { FileDto } from '@tallo/file-manager';

const props = withDefaults(
  defineProps<{
    image: FileDto;
    isCover?: boolean;
    isLarge: boolean;
  }>(),
  {
    isCover: false,
    isLarge: false,
  },
);
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.image-container {
  position: relative;
  width: 13.625rem;
  height: 13.625rem;

  &.large {
    width: 19.5rem;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
    position: relative;
    border-radius: var(--t-border-radius-sm);
    padding: 0;
    margin: 0;
    user-select: none;

    @include mobile {
      height: auto;
      aspect-ratio: 1/1;
    }
  }

  .cover-badge {
    position: absolute;
    bottom: 1rem;
    left: 0.5rem;
    background-color: white;
    padding: 0.25rem 0.5rem;
    font-weight: 500;
    border-radius: var(--t-border-radius-sm);
    font-size: 0.8rem;
  }
}
</style>
